import { useMutation, useQueryClient } from "@tanstack/react-query"
import type { ProductVisualKind } from "@nova-ai/product-visual-templates/kinds"
import { routes, type ProductVisualRegenerationResponse, type StoreCode } from "@nova-ai/shared"

import { apiFetch } from "../lib/api"

export function useProductVisualRegeneration(input: { store: StoreCode; configSku?: string }) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (target: { simpleSku: string; kind: ProductVisualKind }) => {
      const result = await apiFetch<ProductVisualRegenerationResponse>(
        routes.productVisuals.replacement({
          store: input.store,
          simpleSku: target.simpleSku,
        }),
        { method: "POST", body: { kind: target.kind, priority: "urgent" } }
      )
      if (!result.ok) {
        throw new Error(result.error.message)
      }
      return result.value
    },
    onSuccess: async () => {
      await Promise.all([
        ...(input.configSku
          ? [
              queryClient.invalidateQueries({
                queryKey: ["product-config-visuals", input.configSku, input.store],
              }),
            ]
          : []),
        queryClient.invalidateQueries({ queryKey: ["product-visual-images"] }),
        queryClient.invalidateQueries({ queryKey: ["product-visual-worklist"] }),
      ])
    },
  })
}
